import PropTypes from "prop-types";
import { useState } from "react";

export default function CustomInputField({
    label,
    value,
    onChange,
    type,
    required,
    maxLength,
    minLength,
    max,
    min,
    disabled,
    error,
    helperText,
    important,
    readOnly,
    hideLabel,
    height,
    hidden,
    defaultPrefix, // ← new prop for tele prefix like +971
    ...rest
}) {
    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (event) => {
        const { value } = event.target;
        if (type === "number" && maxLength && value.length > maxLength) return;
        if (onChange) onChange(event);
    };

    const handleClickShowPassword = () => setShowPassword(!showPassword);

    return (
        <div className="input-wrapper" style={{ display: hidden ? "none" : "block", margin: "0", ...rest.style }}>
            {!hideLabel && (
                <label style={{ fontWeight: "600", fontSize: "12px", color: "#666666" }}>
                    {label}
                    {important && <span style={{ color: "#f20010", marginLeft: "4px" }}>*</span>}
                </label>
            )}

            {type === "tel" && defaultPrefix ? (
                <div className="tel-input-container">
                    <div className="tel-prefix">{"+" + defaultPrefix}</div>
                    <input
                        className={`custom-input tel-input ${error ? "error" : ""}`}
                        value={value}
                        onChange={handleChange}
                        type="tel"
                        required={required}
                        disabled={disabled}
                        maxLength={maxLength}
                        minLength={minLength}
                        placeholder={`Enter phone number`}
                        readOnly={readOnly}
                        style={{ height }}
                        {...rest}
                    />
                </div>
            ) : (
                <div style={{ position: "relative" }}>
                    <input
                        className={`custom-input ${error ? "error" : ""}`}
                        value={value}
                        onChange={handleChange}
                        type={type === "password" ? (!showPassword ? "password" : "text") : type}
                        required={required}
                        disabled={disabled}
                        maxLength={maxLength}
                        minLength={minLength}
                        max={max}
                        min={min}
                        placeholder={`${label}${important && hideLabel ? " *" : ""}`}
                        readOnly={readOnly}
                        style={{ height }}
                        {...rest}
                    />
                    {type === "password" && (
                        <button
                            type="button"
                            className={showPassword ? "fa-solid fa-eye-slash fa-1x" : "fa-solid fa-eye fa-1x"}
                            style={{
                                position: "absolute",
                                right: "8px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                background: "none",
                                border: "none",
                                color: "#666",
                            }}
                            onClick={handleClickShowPassword}
                        />
                    )}
                </div>
            )}

            {error && <div style={{ color: "red", fontSize: "12px" }}>{helperText}</div>}
        </div>
    );
}

CustomInputField.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    required: PropTypes.bool,
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    max: PropTypes.number,
    min: PropTypes.number,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    important: PropTypes.bool,
    readOnly: PropTypes.bool,
    hideLabel: PropTypes.bool,
    height: PropTypes.string,
    hidden: PropTypes.bool,
    defaultPrefix: PropTypes.string, // ← new prop
};
